import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useNavigate } from "react-router-dom";

interface Brand {
  id: string;
  name: string;
  image: string;
}

const brands: Brand[] = [
  {
    id: "1",
    name: "Miluna",
    image: "/img/Milunaimg2.png",
  },
  {
    id: "2",
    name: "Lorenz",
    image: "/img/Lorenzimg2.png",
  },
  {
    id: "3",
    name: "Citizen",
    image: "/img/Screenshot 2024-11-29 154151.png",
  },
  {
    id: "4",
    name: "Vagary",
    image: "/img/Screenshot 2024-11-29 154928.png",
  },
  {
    id: "5",
    name: "Altre Marche",
    image: "/img/Screenshot 2024-11-29 154813.png",
  },
  {
    id: "6",
    name: "Bliss",
    image: "/img/bliss.jpeg",
  },
];

export const Marchi: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="h-full">
        <Navbar />
        <main className="flex flex-col items-center bg-white w-full h-full py-8 md:py-12 px-4 md:px-6 font-elegant">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 text-center">I Nostri Marchi</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full max-w-7xl">
            {brands.map((brand) => (
              <button
                key={brand.id}
                className="flex flex-col items-center border-2 rounded-lg shadow-md bg-white overflow-hidden hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-green-800 transition-shadow border-green-800 min-h-[44px]"
                onClick={() =>
                  navigate("/lista-marchio", { state: { marca: brand.name } })
                }
                aria-label={`Vedi prodotti del marchio ${brand.name}`}
              >
                <img
                  src={brand.image}
                  alt={`Logo ${brand.name}`}
                  className="w-full h-auto max-h-[200px] object-cover border-[4px] md:border-[7px] border-white border rounded-lg"
                />
                <h2 className="text-lg md:text-xl lg:text-2xl font-medium text-center mt-4 mb-4 px-4">{brand.name}</h2>
              </button>
            ))}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};
